import React from 'react';

import PropTypes from 'prop-types';
import { Button, Form, Icon } from 'semantic-ui-react';

import _isEmpty from 'lodash/isEmpty';

import withCopyToClipboard from 'components/common/CopyToClipboard/CopyToClipboard';

import './ClassNameField.scss';

const propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};

const defaultProps = {
  label: 'Class Name',
};

const CopyToClipboard = withCopyToClipboard(Button);

export default function ClassNameField({ value, onChange: onChangeProp, label }) {
  function onChange(e, target) {
    const { value: newValue } = target;
    const filteredValue = newValue.replace(/[\s\d@!#$%()'"&/=?]/g, '');
    const newTarget = { ...target, value: filteredValue };
    onChangeProp({ ...e, target: newTarget }, newTarget);
  }

  return (
    <Form.Input
      className="class-name-field"
      name="className"
      placeholder="class-name"
      label={label}
      fluid
      value={value}
      onChange={onChange}
      icon={
        <CopyToClipboard icon value={value} disabled={_isEmpty(value)}>
          <Icon name="copy" />
        </CopyToClipboard>
      }
    />
  );
}

ClassNameField.propTypes = propTypes;
ClassNameField.defaultProps = defaultProps;
